module.exports = __webpack_public_path__ + "img/fi-rr-cloud-share.30b18b0e.svg";